import {type Label, Stack, type StackProps} from '@primer/react'
import {clsx} from 'clsx'
import type {ElementType, ReactElement} from 'react'

import itemContainerStyles from './ItemContainer.module.css'

export type StatusProps = {
  statusStyling?: StackProps<ElementType>
  children: ReactElement<typeof Label> | Array<ReactElement<typeof Label>>
  className?: string
}

// eslint-disable-next-line @eslint-react/no-unstable-default-props
const Status = ({statusStyling = {}, children, className}: StatusProps) => {
  const {direction, gap, ...rest} = statusStyling

  return (
    <Stack
      className={clsx(itemContainerStyles.status, className)}
      direction={direction || 'horizontal'}
      gap={gap || 'condensed'}
      wrap={'wrap'}
      {...rest}
    >
      {children}
    </Stack>
  )
}
Status.displayName = 'Status'

export default Status
